import { render, staticRenderFns } from "./LabelItem.vue?vue&type=template&id=c422a780&scoped=true&"
import script from "./LabelItem.vue?vue&type=script&lang=js&"
export * from "./LabelItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelItem.vue?vue&type=style&index=0&id=c422a780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c422a780",
  null
  
)

export default component.exports